module.exports = __webpack_public_path__ + "media/images/mypage/btn04_ov-926483586b5947713ca8baa582c74a0d.gif";